var _text, _text2, _text3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8",
    "data-name": "Group 8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 227.673,
    height: 114.304,
    viewBox: "0 0 227.673 114.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Skillup",
    transform: "translate(0 60.532)",
    fill: "#2e4579",
    fontSize: 48,
    fontFamily: "Trenda-Heavy, Trenda",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Skillup"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Radio",
    transform: "translate(96.673 102.304)",
    fill: "#2e4579",
    fontSize: 48,
    fontFamily: "Trenda-Heavy, Trenda",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Radio"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "Africa",
    transform: "translate(26.257 85.819)",
    fill: "#2e4579",
    fontSize: 17,
    fontFamily: "Trenda-Regular, Trenda"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AFRICA"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-microphone",
    "data-name": "Icon ionic-md-microphone",
    d: "M48.755,14.674V10.387a8.321,8.321,0,0,0-8.51-8.137H17.526A8.324,8.324,0,0,0,9,10.387v4.286H32.6v5.746H9V27.1H32.6v5.746H9v6.678H32.6v5.746H9v6.491a8.3,8.3,0,0,0,8.526,8.106H22.2V71.822H35.555V59.864h4.69a8.3,8.3,0,0,0,8.51-8.106V45.267h-8.7V39.521h8.7V32.843h-8.7V27.1h8.7V20.419h-8.7V14.674Z",
    transform: "translate(157.667 -2.25)",
    fill: "#2e4579"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillogo);
export default __webpack_public_path__ + "static/media/skillogo.3aa35602802343b9fb3ff482ccc6b588.svg";
export { ForwardRef as ReactComponent };